
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"40","width":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.917 15.333v9.334q0 .833.729 1.25.729.416 1.396-.042l7.333-4.708q.667-.417.667-1.167t-.667-1.167l-7.333-4.708q-.667-.458-1.396-.042-.729.417-.729 1.25zM20 36.667q-3.417 0-6.458-1.313-3.042-1.312-5.313-3.583t-3.583-5.313Q3.333 23.417 3.333 20q0-3.417 1.313-6.458Q5.958 10.5 8.229 8.229t5.313-3.583Q16.583 3.333 20 3.333q3.417 0 6.458 1.313 3.042 1.312 5.313 3.583t3.583 5.313q1.313 3.041 1.313 6.458 0 3.417-1.313 6.458-1.312 3.042-3.583 5.313t-5.313 3.583Q23.417 36.667 20 36.667zM20 20zm0 13.875q5.75 0 9.812-4.063Q33.875 25.75 33.875 20q0-5.75-4.063-9.812Q25.75 6.125 20 6.125q-5.75 0-9.812 4.063Q6.125 14.25 6.125 20q0 5.75 4.063 9.812Q14.25 33.875 20 33.875z"}})])
          )
        }
      }
    